import { Phone, Mail, Handshake, MoreHorizontal } from "lucide-react";
import { methodIconKeyOf, type MethodOption } from "@shared-domain/survey/presets";

// 実施方法(phone/mail/meet/other)→ lucide アイコン。一覧カード・タップ4択・完了/詳細で共用。
const ICON_MAP: Record<MethodOption["iconKey"], typeof Phone> = {
  phone: Phone,
  mail: Mail,
  meet: Handshake,
  other: MoreHorizontal,
};

export function MethodIcon({ method, size = 14, color = "#94A3B8", strokeWidth = 2 }: {
  method: string | undefined; size?: number; color?: string; strokeWidth?: number;
}) {
  const key = methodIconKeyOf(method);
  const Ic = key ? ICON_MAP[key] : MoreHorizontal;
  return <Ic size={size} color={color} strokeWidth={strokeWidth} />;
}
